import { render, staticRenderFns } from "./TemplateStagesList.vue?vue&type=template&id=3761bfad&scoped=true"
import script from "./TemplateStagesList.vue?vue&type=script&lang=js"
export * from "./TemplateStagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761bfad",
  null
  
)

export default component.exports